import React, {Fragment, useState} from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";

export const PaymentDrawer = ({
  setStep,
  setSuccess,
  success,
  submitForm,
  isLoading,
}: {
  success: boolean;

  setSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  isLoading: boolean;
  submitForm: (() => Promise<void>) & (() => Promise<any>);
}) => {
  const [selectedPayment, setSelectedPayment] = useState<string>("online");

  return success ? (
    <Transition appear show={success} as={Fragment}>
      <Dialog
        as="div"
        className="!relative !z-10"
        onClose={() => setSuccess(false)}
      >
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="!fixed !inset-0 !bg-black/25" />
        </TransitionChild>

        <div className="!fixed !inset-0 !overflow-y-auto">
          <div className="!flex !min-h-full !items-center !justify-center !p-4 !text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="!w-full !max-w-md !transform !overflow-hidden !rounded-2xl !bg-white !p-6 !text-left !align-middle !shadow-xl !transition-all">
                <div className="!min-w-[371px] !max-w-[371px] !h-full !overflow-hidden">
                  <div className="!h-full !w-full !border !border-gray-100 !bg-gray-25 !overflow-y-scroll !scrollbar-hide !rounded-[20px] !py-6 !px-4 !flex !flex-col !items-center">
                    <svg
                      width="72"
                      height="73"
                      viewBox="0 0 72 73"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M36.0013 0.667969C16.2111 0.667969 0.167969 16.7111 0.167969 36.5013C0.167969 56.2915 16.2111 72.3346 36.0013 72.3346C55.7915 72.3346 71.8346 56.2915 71.8346 36.5013C71.8346 16.7111 55.7915 0.667969 36.0013 0.667969ZM21.1028 36.4002C20.1265 35.4239 18.5436 35.4239 17.5672 36.4002C16.5909 37.3765 16.5909 38.9594 17.5672 39.9357L27.5672 49.9357C28.5436 50.912 30.1265 50.912 31.1028 49.9357L54.4361 26.6024C55.4124 25.6261 55.4124 24.0432 54.4361 23.0669C53.4598 22.0906 51.8769 22.0906 50.9006 23.0669L29.335 44.6324L21.1028 36.4002Z"
                        fill="#287F6E"
                      />
                    </svg>

                    <DialogTitle
                      as="h3"
                      className="!text-[32px] !font-semibold !mt-9 !text-center"
                    >
                      Order Created
                    </DialogTitle>
                    <p className="!text-gray-400 !text-center !mt-2">
                      Your order has been created successfully and a rider will
                      contact you for pickup
                    </p>
                    {/* <button
                      className="!text-sm !font-bold !text-[#fe7f1f] !border !border-[#fe7f1f] !rounded-[10px] !w-full !py-4 !flex !justify-center !items-center !mt-9"
                      onClick={() => {
                        setSuccess(false);
                      }}
                    >
                      View Order
                    </button> */}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  ) : (
    <Transition appear show={!success} as={Fragment}>
      <Dialog
        as="div"
        className="!relative !z-10"
        onClose={() => setSuccess(false)}
      >
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="!fixed !inset-0 !bg-black/25 !bg-opacity-25" />
        </TransitionChild>

        <div className="!fixed !inset-0 !overflow-y-auto">
          <div className="!flex !min-h-full !justify-end !p-4 !text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="!w-full !h-full !max-w-md !transform !overflow-hidden !rounded-2xl !bg-white !p-6 !text-left !align-middle !shadow-xl !transition-all">
                <div className="!h-full !max-w-[400px] !w-full !border !border-gray-100 !bg-gray-25 !overflow-y-scroll !scrollbar-hide !rounded-[20px] !py-6 !px-4 !flex !flex-col">
                  <div className="!relative !flex-1">
                    <p className="!text-[22px] !font-bold !text-gray-700 !mb-2">
                      Choose Payment Option
                    </p>
                    <p className="!text-gray-500 !text-sm !mb-6">
                      Select a payment method you prefer to create order
                    </p>

                    {/* Payment Options */}
                    <div className="!space-y-4 !mb-6">
                      {/* Online Payment Option */}
                      <div className="!border !border-gray-100 !pb-5 !px-3 !rounded-[10px]">
                        <label className="!flex !items-center !gap-3 !cursor-pointer !relative">
                          <div>
                            <input
                              type="radio"
                              name="paymentMethod"
                              value="cash"
                              checked={selectedPayment === "cash"}
                              onChange={() => setSelectedPayment("cash")}
                              className="!absolute !opacity-0 !h-0 !w-0"
                            />
                            <div
                              className={`!absolute !top-6 !left-4 !h-5 !w-5 !rounded-full !border-2 
                            ${
                              selectedPayment === "cash"
                                ? "!border-[#fe7f1f] !bg-[#fe7f1f]"
                                : "!border-gray-100"
                            }`}
                            >
                              {selectedPayment === "cash" && (
                                <div className="!absolute !top-1/2 !left-1/2 !transform !-translate-x-1/2 !-translate-y-1/2 !w-2 !h-2 !bg-white !rounded-full" />
                              )}
                            </div>
                          </div>
                          <div className="!ml-8">
                            <p className="!text-gray-700 !font-medium !text-sm">
                              Pay cash
                            </p>
                            <p className="!text-gray-400 !text-xs">
                              Pay with cash
                            </p>
                          </div>
                        </label>
                      </div>

                      <div className="!border !border-gray-100 !pb-5 !px-3 !rounded-[10px]">
                        <label className="!flex !items-center !gap-3 !cursor-pointer !relative">
                          <div>
                            <input
                              type="radio"
                              name="paymentMethod"
                              value="online"
                              checked={selectedPayment === "online"}
                              onChange={() => setSelectedPayment("online")}
                              className="!absolute !opacity-0 !h-0 !w-0"
                            />
                            <div
                              className={`!absolute !top-6 !left-4 !h-5 !w-5 !rounded-full !border-2 
                            ${
                              selectedPayment === "online"
                                ? "!border-[#fe7f1f] !bg-[#fe7f1f]"
                                : "!border-gray-100"
                            }`}
                            >
                              {selectedPayment === "online" && (
                                <div className="!absolute !top-1/2 !left-1/2 !transform !-translate-x-1/2 !-translate-y-1/2 !w-2 !h-2 !bg-white !rounded-full" />
                              )}
                            </div>
                          </div>
                          <div className="!ml-8">
                            <p className="!text-gray-700 !font-medium !text-sm">
                              Pay online
                            </p>
                            <p className="!text-gray-400 !text-xs">
                              Pay through third party payment provider
                            </p>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="p-5">
                    {selectedPayment === "online" && (
                      <button onClick={submitForm} className="w-full">
                        Proceed to checkout
                      </button>
                    )}
                    {selectedPayment === "cash" && (
                      <button onClick={submitForm} className="w-full">
                        Create order
                      </button>
                    )}

                    <button
                      className="!w-full !bg-gray-200 !py-4 !text-gray-500 !rounded-[10px] !font-bold !text-sm !mt-auto"
                      onClick={() => setStep(3)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
